var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('html',[_c('head'),_c('body',[_c('h2',[_vm._v("MJP 的 Server")]),_c('p',[_vm._v("MJP 使用 CVM（腾讯云服务器）、MySQL 服务器和 Redis 服务器。")])])])])
}]

export { render, staticRenderFns }